module.exports = __webpack_public_path__ + "static/media/projects4.c58baa15.png";